<template>
  <div class="footer">
    <div>
      <strong>IMEA</strong> - Instituto Mato-grossense de Economia Agropecuária.
    </div>
    <div>
      <a
        style="color: #546E7A; font-weight: 600;"
        target="_blank"
        href="http://imea.com.br/imea-site/termo-de-uso.html"
      >
        {{ $t('login.terms') }}
      </a>
      e
      <a
        style="color: #546E7A; font-weight: 600;"
        target="_blank"
        href="http://imea.com.br/imea-site/politica.html"
        >{{ $t('login.privacy') }}</a
      >
    </div>
    <div>
      {{ $t('developed_by') }}
      <a href="http://www.sydy.com.br" target="_blank" class="footer-link"
        >Sydy</a
      >.
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterPanel'
}
</script>
